<template>
  <v-container fluid>
    <LoadingMask :loading="loading" />
    <v-row>
      <!--
      <v-col cols="12" sm="8" align="right">
        <v-btn small rounded class="info ml-4" color="lighten-1" @click="generate">
          Generate report
        </v-btn>
      </v-col>
      -->
      <v-col cols="12">
        <v-tabs vertical>
          <v-tab>General<br>ledger</v-tab>
          <v-tab>Profit<br>loss</v-tab>
          <v-tab>Balance<br>sheet</v-tab>
          <v-tab>GST</v-tab>
          <v-tab-item>
            <v-card :loading="downloadData.generalLedger.downloading">
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <v-btn small rounded color="success" class="mb-2" @click="download('generalLedger')">Download Excel</v-btn>
                    </v-col>
                  </v-row>
                </v-container>
                <v-list>
                  <v-list-group value="true">
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>Bank accounts</v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <v-list-item v-for="(trans, acc) in glBankAccounts" :key="'acc-' + acc">
                      <v-container>
                        <v-row no-gutters>
                          <v-col cols="12">
                            <b>{{ report.opening_balances[acc].name }}</b>
                          </v-col>
                        </v-row>
                        <v-row no-gutters v-for="(t, idx) in trans" :key="t.id" class="py-2"
                          :class="['report-row', isSumTitle(t) ? 'sum-title' : t.trans_type === 'D' ? 'green' : 'orange', 'lighten-4']">
                          <template v-if="idx === 0">
                            <v-col cols="2" class="pl-4"><b>Date</b></v-col>
                            <v-col cols="3"><b>Bank account</b></v-col>
                            <v-col cols="4"><b>Description</b></v-col>
                            <v-col cols="2" align="right"><b>Amount</b></v-col>
                            <v-col cols="1" align="right" class="pr-4"><b>Balance</b></v-col>
                            <v-col cols="12"><v-divider/></v-col>
                          </template>
                          <template v-if="isSumTitle(t)">
                            <v-col offset="9" cols="2" class="pl-4" align="right"><b>{{ title(t) }}</b></v-col>
                            <v-col cols="1" class="pr-4" align="right">
                              {{ N(t.amount) }}
                            </v-col>
                          </template>
                          <template v-else>
                            <v-col cols="2" class="pl-4">{{ t.transtime }}</v-col>
                            <v-col cols="3">{{ t.category_obj.name  || '--' }}</v-col>
                            <v-col cols="4">{{ title(t) }}</v-col>
                            <v-col cols="2" align="right">
                              {{ t.amount }}
                            </v-col>
                            <v-col cols="1" align="right" class="pr-4">
                              {{ N(t.running_balance) }}
                            </v-col>
                          </template>
                        </v-row>
                      </v-container>
                    </v-list-item>
                  </v-list-group>
                  <v-list-group value="expand">
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>Categories</v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <v-list-item v-for="(trans, cat) in glCategories" :key="cat">
                      <v-container>
                        <v-row no-gutters v-for="(t, idx) in trans" :key="t.id" class="py-2"
                          :class="['report-row', isSumTitle(t) ? 'sum-title' : t.trans_type === 'D' ? 'green' : 'orange', 'lighten-4']">
                          <template v-if="idx === 0">
                            <v-col cols="12" class="pl-8">
                              <b>{{ cat }}</b>
                            </v-col>
                            <v-col cols="12" class="pb-2">
                              <v-divider/>
                            </v-col>
                            <v-col cols="2" class="pl-8"><b>Date</b></v-col>
                            <v-col cols="3"><b>Bank account</b></v-col>
                            <v-col cols="4"><b>Description</b></v-col>
                            <v-col cols="1" align="right"><b>Net</b></v-col>
                            <v-col cols="1" align="right"><b>GST</b></v-col>
                            <v-col cols="1" class="pr-8" align="right"><b>Balance</b></v-col>
                            <v-col cols="12" class="px-8"><v-divider/></v-col>
                          </template>
                          <template v-if="isSumTitle(t)">
                            <v-col offset="7" cols="2" class="pl-8" align="right"><b>{{ title(t) }}</b></v-col>
                            <v-col cols="1" align="right">
                              {{ N(t.amount - t.gst, Math.abs) }}
                            </v-col>
                            <v-col cols="1" align="right">
                              {{ N(t.gst, Math.abs) }}
                            </v-col>
                          </template>
                          <template v-else>
                            <v-col cols="2" class="pl-8">{{ t.transtime }}</v-col>
                            <v-col cols="3">{{ t.bank_account_obj.name }}</v-col>
                            <v-col cols="4">{{ title(t) }}</v-col>
                            <v-col cols="1" align="right">
                              <span v-if="cat === 'GST'">0.00</span>
                              <span v-else>{{ N(t.amount - t.gst) }}</span>
                            </v-col>
                            <v-col cols="1" align="right">
                              {{ N(t.gst) }}
                            </v-col>
                            <v-col cols="1" class="pr-8" align="right">
                              {{ N(t.running_balance, Math.abs) }}
                            </v-col>
                          </template>
                        </v-row>
                      </v-container>
                    </v-list-item>
                  </v-list-group>
                </v-list>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card :loading="downloadData.profitLoss.downloading">
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <v-btn small rounded color="success" class="mb-2" @click="download('profitLoss')">Download</v-btn>
                    </v-col>
                  </v-row>
                  <template v-for="(typeData, catType) in report.profit_loss">
                    <v-row no-gutters :key="catType" class="py-2 report-row sum-title">
                      <v-col cols="6" class="pl-8"><b>{{ catType === '_total_' ? 'Net' : catType }}</b></v-col>
                      <v-col cols="6" v-if="typeData.total" class="pr-4" align="right">{{ N(typeData.total) }}</v-col>
                    </v-row>
                    <v-row no-gutters class="py-2 report-row" v-for="(catValue, cat) in typeData.details" :key="cat">
                      <v-col cols="6" class="pl-16"><b>{{ cat }}</b></v-col>
                      <v-col v-if="catValue" class="pr-4" align="right">{{ N(catValue) }}</v-col>
                    </v-row>
                  </template>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card :loading="downloadData.balanceSheet.downloading">
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <v-btn small rounded color="success" class="mb-2" @click="download('balanceSheet')">Download</v-btn>
                    </v-col>
                  </v-row>
                  <template v-for="sect in ['assets', 'liabilities', 'equity']">
                    <v-row no-gutters :key="sect" class="mt-4">
                      <v-col cols="12" style="text-transform:capitalize">
                        <b>{{ sect }}</b>
                      </v-col>
                    </v-row>
                    <template v-for="(item, idx) in report.balance_sheet[sect]">
                      <v-row no-gutters :key="sect + idx" class="py-2 report-row sum-title">
                        <v-col cols="6" class="pl-4" v-if="item.name === '_total_'"><b>Total {{ sect }}</b></v-col>
                        <v-col cols="6" class="pl-8" v-else>{{ item.name }}</v-col>
                        <v-col cols="6" class="pr-4" align="right">{{ N(item.value) }}</v-col>
                      </v-row>
                    </template>
                  </template>
                  <v-row no-gutters class="mt-4">
                    <v-col cols="6"><b>Liabilities plus Equity</b></v-col>
                    <v-col cols="6" class="pr-4" align="right">{{ N(report.balance_sheet.liabilities_equity) }}</v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card :loading="downloadData.gst.downloading">
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <v-btn small rounded color="success" class="mb-2" @click="download('gst')">Download</v-btn>
                    </v-col>
                  </v-row>
                  <template v-for="(gstData, gstType) in report.gst">
                    <v-row no-gutters :key="gstType" class="py-2 report-row sum-title">
                      <v-col cols="6" class="pl-8"><b>{{ gstType === '_total_' ? 'Net GST' : gstType }}</b></v-col>
                      <v-col v-if="gstType === '_total_'" class="pr-4" align="right">{{ N(gstData) }}</v-col>
                    </v-row>
                    <template v-if="gstType !== '_total_'">
                      <v-row no-gutters class="py-2 report-row" v-for="(gst, cat) in gstData" :key="cat">
                        <v-col cols="6" class="pl-8" v-if="cat === '_total_'"><b>TOTAL</b></v-col>
                        <v-col cols="6" class="pl-16" v-else><b>{{ cat }}</b></v-col>
                        <v-col class="pr-4" align="right">{{ N(gst) }}</v-col>
                      </v-row>
                    </template>
                  </template>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { getApi, Api } from '@/services/Api'
import LoadingMask from '@/components/LoadingMask'

@Component({
  components: {
    LoadingMask
  }
})
export default class Report extends Vue {
  report = {
    generaal_ledger: {},
    profit_loss: {},
    balance_sheet: {},
    gst: {}
  }
  inputs = {
    entity: null,
    bank_account: null,
    filters: null
  }
  loading = false
  glBankAccounts = []
  glCategories = []
  downloadData = {
    generalLedger: {
      downloading: false,
      contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      suffix: 'xlsx'
    },
    profitLoss: {
      downloading: false,
      contentType: 'application/pdf',
      suffix: 'pdf'
    },
    balanceSheet: {
      downloading: false,
      contentType: 'application/pdf',
      suffix: 'pdf'
    },
    gst: {
      downloading: false,
      contentType: 'application/pdf',
      suffix: 'pdf'
    }
  }

  generate (entityId = null, bankAccount = null, filters = null) {
    if (entityId !== null) {
      this.inputs.entity = entityId
    }
    if (bankAccount !== null) {
      this.inputs.bank_account = bankAccount
    }
    if (filters !== null) {
      this.inputs.filters = filters
    }

    this.loading = true
    Api().post('/report/', this.inputs)
      .then(resp => {
        this.report = resp.data
        this.glBankAccounts = this.report.general_ledger.accounts
        this.glCategories = this.report.general_ledger.categories
      })
      .finally(() => {
        this.loading = false
      })
  }

  isSumTitle (tran) {
    return /^_.+_$/.test(tran.description)
  }

  title (tran) {
    if (tran.description === '_opening_') {
      return 'OPENING BALANCE'
    }
    if (tran.description === '_total_') {
      return 'TOTAL'
    }
    return tran.description
  }

  N (v, fn = null) {
    try {
      if (v === null) {
        return ''
      }
      if (fn !== null) {
        return fn(parseFloat(v)).toFixed(2)
      }
      return parseFloat(v).toFixed(2)
    } catch (e) {
      return ''
    }
  }

  download (report) {
    const api = getApi(null, { 'Content-Type': 'application/json' }, 'blob')
    const downloadData = this.downloadData[report]
    const report_ = report.replace(/([A-Z])/, '-$1').toLowerCase()
    downloadData.downloading = true

    api.post(`/report/${report_}/download/`, this.inputs)
      .then(resp => {
        const blob = new Blob([resp.data], { type: resp.data.type })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = `${report}_report.${downloadData.suffix}`
        downloadData.downloading = false
        link.click()
        window.URL.revokeObjectURL(link.href)
      })
  }
}
</script>

<style lang="scss">
.pl-16 {
    padding-left: 64px !important;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.report-row {
  border-top: 1px solid #ccc;
  &.sum-title {
    background-color: #eee;
  }
}
</style>
